
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Upload() {
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState('');
  const [location, setLocation] = useState('');
  const navigate = useNavigate();

  const handleUpload = async () => {
    if (!file || !title || !location) {
      alert("Merci de remplir tous les champs.");
      return;
    }

    const formData = new FormData();
    formData.append('media', file);
    formData.append('title', title);
    formData.append('location', location);
    formData.append('project_id', id); // ✅

    const response = await fetch('http://localhost:3001/upload', {
      method: 'POST',
      body: formData
    });

    if (response.ok) {
      alert("✅ Média envoyé avec succès !");
      navigate('/admin');
    } else {
      alert("❌ Échec de l'envoi.");
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '700px' }}>
      <div className="card shadow p-4 rounded-4 border-0" style={{ background: '#f8f9fa' }}>
        <h2 className="mb-4 text-center" style={{ color: '#2c3e50' }}>🎬 Importer un Média</h2>

        <div className="mb-3">
          <label className="form-label fw-bold">Titre</label>
          <input className="form-control form-control-lg" type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="Ex. : Un été à Bali" />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Emplacement</label>
          <input className="form-control form-control-lg" type="text" value={location} onChange={e => setLocation(e.target.value)} placeholder="Ex. : Indonésie" />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Vidéo ou Image</label>
          <input className="form-control form-control-lg" type="file" onChange={e => setFile(e.target.files[0])} />
        </div>

        <button className="btn btn-lg w-100 text-white" style={{ backgroundColor: '#20c997' }} onClick={handleUpload}>
          🚀 Envoyer
        </button>
      </div>
    </div>
  );
}

export default Upload;
